"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _reactGoogleRecaptcha = require("react-google-recaptcha");

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _config = require("config");

var _config2 = _interopRequireDefault(_config);

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _loginFormValidation = require("utils/loginFormValidation");

var _components = require("components");

var _ForgotPasswordPopup = require("@quixeltools/quixel-ui-library/dist/components/common/website/ForgotPasswordPopup");

var _ForgotPasswordPopup2 = _interopRequireDefault(_ForgotPasswordPopup);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputLabel = (0, _glamor.css)(_fonts.subH4, {
  display: "block",
  color: _css.pallets.gray_text,
  textTransform: "uppercase",
  marginBottom: (0, _css.unitRem)(0.25)
});

var ForgotPasswordForm = (_dec = (0, _reduxForm.reduxForm)({
  form: "forgotPassword",
  fields: ["email"],
  validate: _loginFormValidation.validateForgotPassword
}), _dec2 = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, authActions)), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(ForgotPasswordForm, _React$Component);

  function ForgotPasswordForm(props) {
    (0, _classCallCheck3.default)(this, ForgotPasswordForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordForm)).call(this, props));

    _this.state = {
      message: null,
      error: null,
      captchaValue: null
    };
    _this.onForgotPasswordClick = _this.onForgotPasswordClick.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ForgotPasswordForm, [{
    key: "onChange",
    value: function onChange(value) {
      this.setState({ captchaValue: value });
    }

    // onPreSubmit(values) {
    //   values.preventDefault();

    //   const { captchaRef } = this.state;
    //   captchaRef.execute();

    //   return false;
    // }

  }, {
    key: "onForgotPasswordClick",
    value: function onForgotPasswordClick(values) {
      var _this2 = this;

      var captchaValue = this.state.captchaValue;


      this.setState({
        message: null,
        error: null
      });

      if (captchaValue === null) {
        this.setState({ error: "CAPTCHA is missing" });
        return;
      }

      return this.props.forgotPassword(values.email.toLowerCase(), captchaValue).then(function () {
        _this2.setState({
          message: "Sent an email to your inbox for resetting password"
        });
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: "renderCaptcha",
    value: function renderCaptcha() {
      return _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)({ marginTop: 24 }) },
        _react2.default.createElement(
          "div",
          { className: inputLabel },
          "Are you human?"
        ),
        _react2.default.createElement(_reactGoogleRecaptcha2.default, {
          size: "normal",
          ref: "recaptcha",
          sitekey: _config2.default.captchaKey,
          theme: "dark",
          onChange: this.onChange
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          emailInputProps = _props.fields.email,
          submitting = _props.submitting,
          handleSubmit = _props.handleSubmit,
          childReference = _props.childReference;


      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "| Reset your password",
          documentDescription: "Forgot your password? Use your email address to recover your Quixel account in minutes."
        },
        _react2.default.createElement(_ForgotPasswordPopup2.default, {
          icon: "/quixel_2080_logo.png",
          emailInputProps: emailInputProps,
          submitting: submitting,
          error: this.state.error,
          message: this.state.message,
          onSubmit: handleSubmit(this.onForgotPasswordClick),
          onChildRef: childReference,
          captcha: this.renderCaptcha()
        })
      );
    }
  }]);
  return ForgotPasswordForm;
}(_react2.default.Component)) || _class) || _class);
exports.default = ForgotPasswordForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ForgotPassword/ForgotPassword.jsx
// module id = 2889
// module chunks = 0